
import { defineComponent, PropType } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import { formatDate } from '@/helpers/commons/localeHelper'
import { iScorecard } from '../KpiDocumentDesigner'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import KpiDocumentDesignerScorecardsListCardDescriptor from './KpiDocumentDesignerScorecardsListCardDescriptor.json'

export default defineComponent({
    name: 'kpi-edit-scorecard-select-dialog',
    components: { Column, DataTable, Dialog },
    props: { visible: { type: Boolean }, scorecardList: { type: Array as PropType<iScorecard[]> }, dataScorecards: { type: Array as PropType<iScorecard[]>, required: true } },
    emits: ['close', 'scorecardSelected'],
    data() {
        return {
            KpiDocumentDesignerScorecardsListCardDescriptor,
            filters: { global: [filterDefault] } as Object,
            selectedScorecard: null as iScorecard | null
        }
    },
    watch: {
        visible() {
            this.setSelectedKpiAssociations()
        }
    },
    async created() {
        this.setSelectedKpiAssociations()
    },
    methods: {
        getFormattedDate(date: any) {
            return formatDate(date)
        },
        setSelectedKpiAssociations() {
            if (this.dataScorecards[0] && this.scorecardList) {
                const index = this.scorecardList.findIndex((scorecard: iScorecard) => scorecard.name === this.dataScorecards[0].name)
                if (index !== -1) this.selectedScorecard = this.scorecardList[index]
            } else {
                this.selectedScorecard = null
            }
        },
        closeScorecardAssociations() {
            this.selectedScorecard = null
            this.$emit('close')
        },
        addScorecardAssociations() {
            this.$emit('scorecardSelected', this.selectedScorecard)
        }
    }
})
